// src/components/dashboard/masteradmin/TopCoursesList.js
import React from 'react';
import { Table } from 'react-bootstrap';
import DashboardCard from '../DashboardCard';

function TopCoursesList({ data, loading }) {
  return (
    <DashboardCard
      title="Top Requested Courses"
      icon="bi-list-ol"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No course requests yet."
    >
      <Table borderless size="sm" className="mb-0 align-middle">
        <tbody>
          {data.map((course, index) => (
            <tr key={course.courseTitle}>
              <td className="text-muted" style={{ width: '2rem' }}>{index + 1}</td>
              <td className="fw-semibold">{course.courseTitle}</td>
              <td className="text-end text-muted">{course.requestCount} requests</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </DashboardCard>
  );
}

export default TopCoursesList;
